import React from 'react';
import { Check, Star, Crown, Award } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

const PACKAGES = [
  {
    id: 'essential',
    name: 'Essential',
    priceLabel: '$6,997',
    priceNote: 'Por hora terminada*',
    color: 'from-[#272b96] to-[#3a3fc0]',
    icon: Star,
    cta: 'EMPIEZA HOY',
    features: [
      'Audiolibro',
      'Publicación en Viubux.com en Venta directa y Suscripción (ViubuxConnect)',
      'Entrevista para Viubux Podcast y dar a conocer tu obra a la comunidad',
      'Book Trailer',
      'QR de acceso directo',
      'Distribución Ebook en Viubux.com',
    ],
  },
  {
    id: 'platino',
    name: 'Platino',
    priceLabel: '$13,997',
    priceNote: 'Por hora terminada*',
    color: 'from-[#aa2aff] to-[#7012b2]',
    icon: Award,
    recommended: true,
    cta: 'Lo quiero!',
    features: [
      'Publicación de Audiolibro',
      'Publicación de Videolibro',
      'Entrevista para Viubux Podcast',
      'Página web App Index con Código QR',
      'Separador Digital',
      'Distribución de Audiolibro en Multiplataforma',
      'Distribución de EBook Multiplataforma',
    ],
  },
  {
    id: 'premium',
    name: 'Premium',
    priceLabel: '$21,997',
    priceNote: 'Por hora terminada*',
    color: 'from-[#7012b2] to-[#aa2aff]',
    icon: Crown,
    cta: 'ES PARA MI',
    features: [
      'Lo mismo que el paquete Platino',
      'Photoshoot en el estudio',
      'Mini Masterclass en Video en Viubux.com',
      'Tarjeta de Presentación NFC',
      'PASE VIP + NFT*',
      'Kit legal (ISBN Audiolibro)',
      'Página web comercial',
      'Presentación de tu Libro en nuestro Foro* Bono $7,500',
      'Distribución Multiplataforma Todos los Formatos',
    ],
  },
];

export function PackageDetailsModal({ isOpen, onClose, onSelectPackage }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[900px] max-h-[90vh] overflow-y-auto bg-[#0a0e2a] border-white/10 text-white p-0">
        <DialogHeader className="p-6 pb-2">
          <DialogTitle className="text-2xl font-bold text-center text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Paso 1 - Elije un paquete
          </DialogTitle>
          <p className="text-slate-400 text-sm text-center mt-1">
            Compara lo que incluye cada paquete de producción de audiolibro
          </p>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-6 pt-2">
          {PACKAGES.map((pkg) => {
            const Icon = pkg.icon;
            return (
              <div
                key={pkg.id}
                className={`relative flex flex-col rounded-2xl border p-5 transition-all ${
                  pkg.recommended
                    ? 'border-[#aa2aff] shadow-[0_0_30px_rgba(170,42,255,0.25)] bg-gradient-to-b from-[#1a1f50]/90 to-[#0a0e2a]'
                    : 'border-white/15 bg-[#0f133a]/80 hover:border-white/30'
                }`}
                data-testid={`package-detail-${pkg.id}`}
              >
                {pkg.recommended && (
                  <div className="absolute -top-3 right-4 bg-[#aa2aff] text-white text-xs font-bold px-3 py-1 rounded-full">
                    Recomendado
                  </div>
                )}

                <div className="mb-3">
                  <div className="flex items-center gap-2 mb-2">
                    <div className={`p-1.5 rounded-lg bg-gradient-to-br ${pkg.color}`}>
                      <Icon className="w-4 h-4 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-white">{pkg.name}</h3>
                  </div>
                  <div className="flex items-baseline gap-1">
                    <span className="text-3xl font-black text-white">{pkg.priceLabel}</span>
                  </div>
                  <p className="text-slate-400 text-xs mt-0.5">{pkg.priceNote}</p>
                </div>

                <div className="mb-4">
                  <p className="text-white font-semibold text-sm mb-2">Incluye</p>
                  <ul className="space-y-2">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <Check className="w-4 h-4 text-[#aa2aff] flex-shrink-0 mt-0.5" />
                        <span className="text-slate-300 text-xs leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mt-auto">
                  <Button
                    onClick={() => {
                      if (onSelectPackage) onSelectPackage(pkg.id);
                      onClose(false);
                    }}
                    className={`w-full font-bold text-sm ${
                      pkg.recommended
                        ? 'bg-[#aa2aff] hover:bg-[#8a1ad9] text-white'
                        : 'bg-white/10 hover:bg-white/20 text-white border border-white/20'
                    }`}
                    data-testid={`btn-select-package-${pkg.id}`}
                  >
                    {pkg.cta}
                  </Button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="px-6 pb-6">
          <p className="text-slate-500 text-xs text-center">
            * Precio por hora terminada de audio. Los descuentos por volumen aplican automáticamente.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default PackageDetailsModal;
